'use client';

import React, { ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: null | Error;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI

    return { hasError: true, error };
  }
  override async componentDidCatch(error, errorInfo) {
    // You can use your own error logging service here
    if (process.env['NODE_ENV'] === 'development') console.log({ error, errorInfo });
  }

  private handleRefresh = () => {
    window.location.reload();
  };
  override render() {
    // Check if the error is thrown
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1 style={{ fontSize: '14px', fontWeight: 'bold' }}>Error</h1>;
    }

    // Return children components in case of no error
    return this.props.children;
  }
}

export default ErrorBoundary;
